import * as swiper from './_swiper';
import * as smoothScroll from './_smoothScroll';
import * as toggleMenu from './_subMenu';
import * as drawer from './_drawer';
import * as pageUp from './_pageUp';
import * as layerboard from './_layerboard';

function init() {
  swiper.init();
  smoothScroll.init();
  toggleMenu.init();
  drawer.init();
  pageUp.init();
  layerboard.init();
}
init();
